/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { StepComponentProps } from 'react-step-builder'
import analytics from '../../libs/analytics'
import api from '../../libs/api'
import navigationUtil from '../../libs/navigationUtil'
import { ReduxState } from '../../reducers'

function StepEnd(props: StepComponentProps) {
  const [loading, setLoading] = useState(false)
  const { password = '' } = props.state
  const { form } = useSelector((state: ReduxState) => ({
    form: state.form,
  }))

  const { email } = form

  useEffect(() => {
    window.onbeforeunload = null
    analytics.sendEvent('page@StepEnd')
    handleClickNext()
  }, [])

  const handleClickNext = async () => {
    try {
      setLoading(true)
      const result = await api.authLoginLocalCreate({ email, password: password as string })
      analytics.sendEvent('Onboard@StepEnd.ClickNext')
      navigationUtil.navigateToHrLogin(email, result.data.token)
    } catch (err) {
      console.log('err', err)
    } finally {
      setLoading(false)
    }
  }

  return null
}

export default StepEnd
